define("settings/controllers/subscription/billing/email", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/service", "ember-concurrency"], function (_exports, _asyncArrowRuntime, _controller, _service, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/service",0,"ember-concurrency"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let BillingEmailController = _exports.default = (_class = class BillingEmailController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "settings", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
      _defineProperty(this, "handleRouteWillChange", transition => {
        this.confirmRouteChange.perform(transition);
      });
      _defineProperty(this, "confirmRouteChange", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (transition) {
          if (this.emailChangeset.isDirty) {
            transition.abort();
            yield this.settings.confirmClose(this.emailChangeset.isDirty);
            this.emailChangeset.rollback();
            transition.retry();
          }
        }
      }), null, "confirmRouteChange", "drop"));
      _defineProperty(this, "handleClose", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.settings.confirmClose(this.emailChangeset.isDirty);
          this.emailChangeset.rollback();
          this.router.transitionTo('account.subscription.billing');
        }
      }), null, "handleClose", "drop"));
      _defineProperty(this, "handleSubmit", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            yield this.settings.submitForm.perform(yield this.emailChangeset.save(), 'account.subscription.billing.edit');
            this.alerts.success(this.intl.t('account.subscription.billing.email.success.message'), {
              title: this.intl.t('account.subscription.billing.email.success.title')
            });
            yield this.handleClose.perform();
          } catch ({
            alert
          }) {
            this.emailChangeset.rollback();
            if (alert) {
              this.alerts.add(alert);
            }
          }
        }
      }), null, "handleSubmit", "drop"));
    }
    // Set in route's setupController hook

    get isEditDisabled() {
      return this.settings.submitForm.isRunning;
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get isSaveDisabled() {
      return false;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});